var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDowntrendLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 16,
    viewBox: "0 0 43 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 14.7109C42 14.7109 36.5278 8.5916 31.6157 7.68543C27.8806 6.99637 25.7119 9.38909 21.9476 8.85634C16.1189 8.03142 15.0024 2.13894 9.23581 0.994481C6.02133 0.356519 1 0.994463 1 0.994463",
    stroke: "#ED544E",
    strokeWidth: 1.18059,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowntrendLine);
export default __webpack_public_path__ + "static/media/downtrend-line.becb5d91e2878bf7b6f0603d0742af6f.svg";
export { ForwardRef as ReactComponent };